import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosPrivate from "../../services/api";
import toast from "react-hot-toast";

export const asyncGetUsers = createAsyncThunk(
  "getUsers",
  async (obj, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
    const { limit, page, query } = obj;

    try {
      const response = await axiosPrivate.get(
        `/v2/users${`?limit=${limit}&page=${page}`}${
          query ? `&query=${query}` : ""
        }`
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);
      throw rejectWithValue(error.response.data.message);
    }
  }
);

export const asyncCreateUser = createAsyncThunk(
  "createUsers",
  async (obj, { dispatch, getState, rejectWithValue, fulfillWithValue }) => {
    const { data, callback } = obj;
    try {
      const response = await axiosPrivate.post("/users", data);
      toast.success("User create Successfully");
      callback && callback();
      return fulfillWithValue(response.data);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);
      throw rejectWithValue(error.response.data.message);
    }
  }
);

export const asyncUpdateUser = createAsyncThunk(
  "updateUser",
  async (
    { id, data, callback },
    { dispatch, getState, rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const response = await axiosPrivate.patch(`/users/${id}`, data);
      toast.success("User Update Successfully");
      callback && callback();
      return fulfillWithValue(response.data);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);
      throw rejectWithValue(error.response.data.message);
    }
  }
);
export const asyncDeleteUser = createAsyncThunk(
  "deleteUser",
  async (
    payload,
    { dispatch, getState, rejectWithValue, fulfillWithValue }
  ) => {
    const { id } = payload;

    try {
      await axiosPrivate.delete(`/users/${id}`);
      // toast.success("fare Update Successfully");
      return fulfillWithValue(id);
    } catch (error) {
      console.log("err==>", error.response.data.message);
      toast.error(error.response.data.message);

      throw rejectWithValue(error.response.data.message);
    }
  }
);
const userSlice = createSlice({
  name: "users",
  initialState: {
    isLoading: false,

    list: [],
    isError: false,
    add: {},
    update: {},
  },
  extraReducers: (builder) => {
    // Cases for Get Users

    builder.addCase(asyncGetUsers.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(asyncGetUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.list = action.payload;
      state.isError = false;
      state.message = null;
    });
    builder.addCase(asyncGetUsers.rejected, (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.isError = true;
    });

    // Cases for Add User
    builder.addCase(asyncCreateUser.pending, (state, action) => {
      state.add = { isLoading: true };
    });
    builder.addCase(asyncCreateUser.fulfilled, (state, action) => {
      state.add = { isLoading: false, message: "User Created Successfully!" };
      state.list.push(action.payload);
    });

    builder.addCase(asyncCreateUser.rejected, (state, action) => {
      state.add = { isLoading: false, message: action.payload };
    });

    // Cases for Update User
    builder.addCase(asyncUpdateUser.pending, (state, action) => {
      state.update = { isLoading: true };
    });
    builder.addCase(asyncUpdateUser.fulfilled, (state, action) => {
      state.add = { isLoading: false, message: "User Updated Successfully!" };
      state.list = state.list.map((x) =>
        x._id === action.payload._id ? action.payload : x
      );
    });

    builder.addCase(asyncUpdateUser.rejected, (state, action) => {
      state.update = { isLoading: false, message: action.payload };
    });

    // Cases for Delete User

    builder.addCase(asyncDeleteUser.fulfilled, (state, action) => {
      console.log(action.payload, "action.payload", state);

      state.list = state.list.filter((x) => x._id !== action.payload);
      // state.list = state.list.map((x) =>
      //   x._id === action.payload._id ? action.payload : x
      // );
    });
  },
  reducers: {},
});

// export const { } = userSlice.actions;
export default userSlice.reducer;
